import React from 'react';
import { ChevronRight, Users, Briefcase, Globe, Building } from 'lucide-react';

const TalentPage = () => {
  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-blue-900 to-indigo-900">
      <div className="relative pt-16 pb-20 sm:pt-24 sm:pb-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl md:text-6xl">Coming soon... </h1>
            \n
            <h1 className="text-4xl font-bold mb-6 text-white">
              <span className="block">Shape the Future of</span>
              <span className="block text-blue-400">Quantum Computing</span>
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-lg text-gray-300">
              Join the quantum revolution. Whether you're seeking opportunities or looking to build your quantum team, Qubiteers connects talent with innovation.
            </p>
            
            <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
              <button className="rounded-md bg-blue-500 px-6 py-3 text-white hover:bg-blue-600 flex items-center justify-center">
                Browse Opportunities
                <ChevronRight className="ml-2 h-4 w-4" />
              </button>
              <button className="rounded-md border border-white px-6 py-3 text-white hover:bg-white/10 flex items-center justify-center">
                Post a Job
              </button>
            </div>

            {/* Talent Fulfillment Section */}
            <div className="mt-12 bg-white/10 rounded-lg p-6 max-w-3xl mx-auto backdrop-blur-sm">
              <h2 className="text-2xl font-semibold text-white mb-3">Talent Fulfillment Services</h2>
              <p className="text-gray-300 mb-4">
                Looking to build your quantum team? Our specialized recruitment services help organizations find and secure top quantum talent.
              </p>
              <button className="bg-white text-blue-900 px-6 py-2 rounded-md hover:bg-gray-100 transition-colors flex items-center mx-auto">
                Partner with Us
                <Building className="ml-2 h-4 w-4" />
              </button>
            </div>

            {/* Key Stats/Features */}
            <div className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-3">
              <div className="flex flex-col items-center">
                <Globe className="h-12 w-12 text-blue-400" />
                <h3 className="mt-4 text-xl font-semibold text-white">Global Network</h3>
                <p className="mt-2 text-gray-300">Access talent and opportunities worldwide</p>
              </div>
              <div className="flex flex-col items-center">
                <Briefcase className="h-12 w-12 text-blue-400" />
                <h3 className="mt-4 text-xl font-semibold text-white">Industry Expertise</h3>
                <p className="mt-2 text-gray-300">Specialized in quantum computing recruitment</p>
              </div>
              <div className="flex flex-col items-center">
                <Users className="h-12 w-12 text-blue-400" />
                <h3 className="mt-4 text-xl font-semibold text-white">End-to-End Solutions</h3>
                <p className="mt-2 text-gray-300">From talent sourcing to team building</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TalentPage;